import { ProjectAPI } from 'api/project';
import { Filter } from 'components/molecules/filters/types';
import type { ColumnOrder } from 'components/organisms/grid-custom-column';
import type { FilterableField } from 'components/organisms/tasks/fields';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { GroupSeparator } from 'components/organisms/tasks/filters/separators';

export const exportAsCSV = (
  filter: Filter,
  fields: Record<string, FilterableField>,
  columnOrder: ColumnOrder[],
): Promise<void> => {
  const validFilters = filter.criteria.filter(FieldFilter.isValid);

  const validColumnOrder = columnOrder
    .filter((item) => !item.hide)
    .map((x) => {
      const field = fields[x.colId!];

      if (field) {
        if (field.customField && field.userCreated) {
          return `${field.sourceType}${GroupSeparator}field.${field.fieldId}`;
        }

        return `${field.sourceType}${GroupSeparator}${x.colId}`;
      }

      return '';
    })
    .filter(Boolean);

  return ProjectAPI.exportAsCSV(
    validFilters,
    filter.type,
    validColumnOrder,
  ).then((downloadUrl) => {
    window.open(downloadUrl, '_blank');
  });
};
